import { Component } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { InstallMspAppBadgesComponent } from 'mbs-ui-shared@components';

@Component({
  selector: 'mbs-install-msp-app-instruction',
  templateUrl: './install-msp-app-instruction.component.html',
  standalone: true,
  imports: [InstallMspAppBadgesComponent, I18NextPipe]
})
export class InstallMspAppInstructionComponent {}
